import { render, staticRenderFns } from "./MachineFileRevision.vue?vue&type=template&id=989dcb00&"
import script from "./MachineFileRevision.vue?vue&type=script&lang=js&"
export * from "./MachineFileRevision.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports